import { render, staticRenderFns } from "./dialog-select-model.vue?vue&type=template&id=3f234e5d&scoped=true"
import script from "./dialog-select-model.vue?vue&type=script&lang=js"
export * from "./dialog-select-model.vue?vue&type=script&lang=js"
import style0 from "./dialog-select-model.vue?vue&type=style&index=0&id=3f234e5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f234e5d",
  null
  
)

export default component.exports